<section id="form">
    <form
      [formGroup]="formulario"
      (ngSubmit)="onSubimitFormulario()"
      class="form container bg-color-light-grey color-dark"
    >
      <h2 class="form-title text-center">
        Consulta Pública<br>
        Proposta de áreas tecnológicas
      </h2>
  
      <div class="form-group">
        <label class="form-label">
          Nome*:
          <app-required-text formControlName="nome" name="nome"></app-required-text>
        </label>
      </div>
  
      <div class="form-group">
        <label class="form-label">
          E-mail*:
          <app-required-text formControlName="email" name="email" id="email"></app-required-text>
        </label>
      </div>
  
      <div class="form-group">
        <label class="form-label">
          Instituição/Empresa:
          <input type="text" class="form-control" formControlName="instituicaoEmpresa" />
        </label>
      </div>
  
      <div class="form-group">
        <label class="form-label">
          Sua sugestão é para*:
          <select formControlName="sugestaoPara" class="form-control select">
            <option *ngFor="let local of localAlteracao" [ngValue]="local">{{ local }}</option>
          </select>
        </label>
  
        <ng-container
          *ngIf="!formulario.get('sugestaoPara').valid && formulario.get('sugestaoPara').touched"
        >
          <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
        </ng-container>
      </div>
  
      <div class="form-group">
        <label class="form-label">
          Eixo tecnológico*:
          <select formControlName="eixoTecnologicoCatalogosId" class="form-control select" id="eixo">
            <option *ngFor="let eixo of eixos" [ngValue]="eixo.id">{{ eixo.nome }}</option>
          </select>
        </label>
        <ng-container
          *ngIf="
            !formulario.get('eixoTecnologicoCatalogosId').valid &&
            formulario.get('eixoTecnologicoCatalogosId').touched
          "
        >
          <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
        </ng-container>
      </div>
  
      <ng-container *ngIf="formulario.get('sugestaoPara').value === 'Área tecnológica (criação de uma nova área)'">
        <div class="form-group form-area">
            <app-custom-form
            [enviouForm]="enviouFormulario"
            [display]="true"
            (alterouValorProposta)="formulario.get('propostaNovaAreaTecnologica').setValue($event)"
            (alterouValorJustificativa)="formulario.get('justificativaNovaAreaTecnologica').setValue($event)"
            ></app-custom-form>
        </div>
      </ng-container>

      <div class="form-group" *ngIf="formulario.get('sugestaoPara').value == 'Área tecnológica (alteração de uma área proposta)'">
        <label class="form-label">
          Área tecnológica*:
          <select formControlName="areaTecnologicaCatalogosId" class="form-control select" id="area">
            <option *ngFor="let area of areas" [ngValue]="area.id">{{ area.nome }}</option>
          </select>
        </label>
        <ng-container
          *ngIf="
            !formulario.get('areaTecnologicaCatalogosId').valid &&
            formulario.get('areaTecnologicaCatalogosId').touched
          "
        >
          <span class="color-red error-msg"> O preenchimento desse campo é obrigatório </span>
        </ng-container>
      </div>

      <ng-container
      *ngIf="
        formulario.get('areaTecnologicaCatalogosId').dirty && formulario.get('sugestaoPara').value === 'Área tecnológica (alteração de uma área proposta)'
      "
    >
      <h2 class="form-subtitle text-center">
        Selecione "Adicionar sugestão" para os itens que você deseja enviar uma contribuição
      </h2>
      <div class="form-group" *ngFor="let campo of camposAreaTecnologica">
        <app-custom-form
        [enviouForm]="enviouFormulario"
        [label]="campo.label"
        (alterouValorProposta)="formulario.get(campo.fields.proposta).setValue($event)"
        (alterouValorJustificativa)="formulario.get(campo.fields.justificativa).setValue($event)"
        (removeuCampo)="limpaValidadores([campo.fields.proposta, campo.fields.justificativa]); sub()"
        (adicionouCampo)="adicionaValidadorCampoRequerido([campo.fields.proposta, campo.fields.justificativa]); add()"
        ></app-custom-form>
      </div>
    </ng-container>

  
      <div class="form-checkbox form-group">
        <input id="termo" type="checkbox" class="input-checkbox" formControlName="aceitaTermo" />
        <label class="label-checkbox" for="termo">{{textoTermo}}</label>
      </div>
  
      <p class="red text-center error" *ngIf="formulario.hasError('nenhumCampoAdicionado')">
        É necessário o preenchimento de ao menos um dos ítens acima
      </p>
  
  
      <div class="recaptcha">
        <re-captcha
          formControlName="reCaptcha"
          siteKey="6LfndeMcAAAAAPSpZjo6cC9PLyKLBKbZ2FJSyuIM"
        ></re-captcha>
      </div>
  
      <div class="wrapper">
        <button
          class="btn btn-md rounded-pill btn-dark cursor-pointer"
          [ngClass]="{ shake: formErro }"
          id="botao-form"
          role="button"
        >
          Enviar
        </button>
      </div>
  
      <app-popup
        [tipoFormulario]="'sugestao'"
        [resposta]="resposta"
        [mostrarPopUp]="mostarPopUp"
        (cancel)="cancelar()"
        (submit)="onSubimitFormulario()"
        [erro]="erro"
      ></app-popup>
      
    </form>
  </section>
  